import SPQSFormGroup from "./SPQSFormGroup";

const QSSPEcon = () => {
  return (
    <>
      <fieldset>
        <legend>Sales Price</legend>
        <SPQSFormGroup labelname={"Sales Price"} inputname={"salesprice"} inputtype={"currency"} />
      </fieldset>
      <fieldset>
        <legend>Economics</legend>
        <SPQSFormGroup readOnly labelname={"Profit"} inputname={"profitpmt"} inputtype={"currency"} />
        <SPQSFormGroup readOnly labelname={"Margin"} inputname={"profittotal"} inputtype={"currency"} />
        <SPQSFormGroup readOnly labelname={"Turnover"} inputname={"turnover"} inputtype={"currency"} />
        <SPQSFormGroup readOnly labelname={"% Margin"} inputname={"margin"} inputtype={"percent"} />
        <SPQSFormGroup readOnly labelname={"Netback"} inputname={"netback"} inputtype={"currency"} />
      </fieldset>
    </>
  );
};

export default QSSPEcon;
